const rawBackendUrl = process.env.REACT_APP_BACKEND_URL || '';

function normalizeBackendUrl(url) {
  const trimmed = url.trim().replace(/\/+$/, '');
  if (!trimmed) {
    return '';
  }

  return trimmed.replace(/\/login$/i, '');
}

export const BACKEND_URL = normalizeBackendUrl(rawBackendUrl);
export const API = `${BACKEND_URL}/api`;
